import { ContactTemplatePage } from '.';

export const ContactFireBrigadeContent = () => {
  return (
    <div className="text-bodyLg flex flex-col gap-4">
      <p>
        If liquid is leaking from the vehicle, contact the emergency services
        immediately.
      </p>
      <p>
        <span className="font-bold">Telephone:</span>
        {` `}999
      </p>
      <p>
        <span className="font-bold">Hearing or speech impairments:</span>
        {` `}If you have a hearing or speech impairment, use their textphone
        service 18000 or text 999 if you've pre-registered with the{` `}
        <a
          href="https://www.relayuk.bt.com/how-to-use-relay-uk/contact-999-using-relay-uk.html"
          target="_blank"
          rel="noreferrer"
          className="text-link-colour underline"
        >
          emergency SMS service
        </a>
        .
      </p>
    </div>
  );
};

export const ContactFireBrigadePage = () => {
  return (
    <ContactTemplatePage
      title="Contact the fire brigade"
      content={<ContactFireBrigadeContent />}
    />
  );
};
